import React from 'react';
import PastEventsView from './PastEventsView';

export const PastEventsContainer = () => {
  return (
    <div>
      <PastEventsView />
    </div>
  );
};
